"use strict";exports.__esModule=true;exports.ATOMIC_DATA_TYPE=exports.STRETCH=exports.END=exports.START=exports.CENTER=exports.DISPLAY_FLEX=exports.DISPLAY_GRID=void 0;var DISPLAY_GRID="grid",DISPLAY_FLEX="flex",CENTER="center",START="start",END="end",STRETCH="stretch",ATOMIC_DATA_TYPE=["string","number","function","boolean","undefined"];exports.ATOMIC_DATA_TYPE=ATOMIC_DATA_TYPE;exports.STRETCH=STRETCH;exports.END=END;exports.START=START;exports.CENTER=CENTER;exports.DISPLAY_FLEX=DISPLAY_FLEX;exports.DISPLAY_GRID=DISPLAY_GRID;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/core/src/_internal/vendors/faberjs/src/utils/constants.js
// module id = e9b5
// module chunks = 5